// Import .less entry point
import '../assets/private/stylesheets/checkout/_checkout.less';
import './checkout/styles/style';

import './legacy/cart/cart.legacy';

/** specific country imports */
import { init as initCountrySpecific } from '@/_override/checkout/checkout-country.entry';
import '@/_override/checkout/checkout-country.less';
/** end of specific country imports */

import { init as initCart } from './checkout/cart/cart';
import { init as initBuyLaterList } from './checkout/cart/buy-later-list';
import { init as initShipping } from './modules-es5/checkout/shipping/shipping';
import { init as initBillingAddress } from './modules-es5/checkout/billingAddress';
import { init as initPayment } from './checkout/payment/payment';
import { init as initPaymentConfirmation } from './checkout/confirmation/confirmation';
import { init as initTrustedShops } from './checkout/confirmation/trusted-shops';
import { init as initStoreInfos } from './checkout/confirmation/get-store-infos';
import { init as initFapiao } from './checkout/payment/fapiao';
import { init as initLostPassword } from './customer/authentication/authentication-lost-password';
import { initCheckout as initSecondaryPayment } from './checkout/payment/payment-secondary';
import { init as initOnePay } from './checkout/payment/payment-onepay';

// Import analytics
import { init as initAnalytics } from './analytics/routes/checkout.anly.route';

document.addEventListener('DOMContentLoaded', () => {


  // ITALIAN FISCAL INVOICE (FATTURA FISCALE)
  if (cube.$id('fiscal-invoice')) {
    import(/* webpackChunkName: "gift-card" */ './checkout/payment/FiscalInvoice/FiscalInvoice').then(
      ({ init: initFiscaleInvoice }) => initFiscaleInvoice()
    );
  }

  // Cart
  if (cube.$('body.checkout-cart')) {
    initCart();
    initBuyLaterList();
  }

  // Authentication //
  const form = cube.$id('js-create-account-form');
  if (form) {
    import(/* webpackChunkName: "checkout-create-account" */ './create-account.route').then(({ init }) => init());
  }

  // Complete //
  const formCreate = cube.$id('js-complete-account-form');
  if (formCreate) {
    import(/* webpackChunkName: "checkout-complete-account" */ './complete-account.route').then(({ init }) => init());
  }

  // Shipping
  if (cube.$('body.checkout-delivery')) {
    initShipping();
    initBillingAddress();
  }

  // Payment
  if (cube.$('body.checkout-payment')) {
    initBillingAddress();
    if (cube.$id('dkt-payment-kit')) {
      initOnePay();
    } else {
      initPayment();
      initFapiao();
      initSecondaryPayment();
    }

    // Payolution Fraud Prevention (DE only)
    if (cube.env.country === 'DE') {
      import(
        /* webpackChunkName: "payolution-fraud-prevention" */ './checkout/payolution-fraud-prevention'
      ).then(({ init: initPayolutionFraudPrevention }) => initPayolutionFraudPrevention());
    }
  }

  // Confirmation
  if (cube.$id('checkout-confirmation')) {
    initPaymentConfirmation();
    initTrustedShops();

    if (cube.$('[data-store-id]')) initStoreInfos();
  }

  if (cube.$id('lost-password')) initLostPassword();

  initCountrySpecific();
  if ( window.cube.config.anly_useLegacy === 'Y') {
    initAnalytics();
  }
});



// WEBPACK FOOTER //
// ./src/checkout.route.js